import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class SendGetParamHistoryRequest extends Request {
    constructor(param_id, duration) {
        super({
            req: RequestTypes.GET_PARAM_HISTORY,
            req_id: 0,
            param_id: param_id,
            duration: duration
        });
    }
}

export default SendGetParamHistoryRequest;